import { css } from 'lit';

const styles = [
  css`
    input::-ms-reveal {
      display: none;
    }
  `,
];

export default styles;
